import _ = require("lodash");
import { EntityConfiguration } from "../../configurations/configuration";
import { ErrorCodes } from "../../util/UIConstants";
import { UniversalService } from "../universal/UniversalService";
import { ServiceDataModel } from "../models/Models";
import { translateToServiceDataModel } from "../../helpers/common/DataUtilityHelper";
import { EndPoint } from "../../util";
import { getAccessToken } from "../../auth/msal";
import { ServiceUrlHelper } from "../../helpers/ServiceUrlHelper";
import { APIMiddleware } from "../../helpers/api-middleware";
import { TemplateService } from "../template/TemplateService";
import { ClientRequestUIExcelInterface } from "./ClientRequestUIExcelInterface";

export class ClientRequestService extends TemplateService {
  async downloadDataAsync(
    engagementId: string,
    configuration: EntityConfiguration,
    inputObjectParameter,
    ldcVersioning
  ): Promise<ServiceDataModel> {
    let dataModel: ServiceDataModel = await this.downloadClientRequestReferenceDataAsync(engagementId, ldcVersioning);

    if (configuration) {
      // if no error in api call for reference data then don't call api, will check ToDo
      let templateGetApi = configuration?.entityConfiguration["apiTemplate"]?.get;
      if (templateGetApi?.url) {
        let clientRequestModal = await super.downloadDataAsync(
          engagementId,
          configuration,
          inputObjectParameter,
          ldcVersioning
        );
        if (!clientRequestModal.ErrorCode) {
          dataModel.response = clientRequestModal.response;
        }

        dataModel.ErrorCode = dataModel.ErrorCode || clientRequestModal.ErrorCode;
      }
    }

    return dataModel;
  }

  async saveDataAsync(
    engagementId: string,
    modifedRequests: any,
    configuration: EntityConfiguration,
    APIBatchProcessingCounter,
    updatedModifiedRequest
  ): Promise<any> {
    // remove saveDataAsync from here as we are using template engine now after identifying the entity type APIBatchProcessingCounter.current  is working
    const errorMessage = await super.saveDataAsync(
      engagementId,
      modifedRequests,
      configuration,
      APIBatchProcessingCounter,
      updatedModifiedRequest
    );
    // APIBatchProcessingCounter.current = APIBatchProcessingCounter.current + 1;
    return errorMessage;
  }

  async downloadClientRequestReferenceDataAsync(engagementId: string, ldcVersioning): Promise<ServiceDataModel> {
    // get the valid hercules incountry uri from the universal home.json call for the engagement
    let modal: ServiceDataModel = new ServiceDataModel();
    let herculesApiBaseUriAsync: EndPoint = await UniversalService.getHerculesApiBaseUriAsync(engagementId);
    if (herculesApiBaseUriAsync.ErrorCode) {
      modal.ErrorCode = herculesApiBaseUriAsync.ErrorCode;
      return modal;
    }
    // get the client requests from the hercules incontry api call
    const herculesAccessToken: string = await getAccessToken({
      audience: herculesApiBaseUriAsync.audienceUrl,
      url: herculesApiBaseUriAsync.serviceUrl,
    });

    if (_.isEmpty(herculesAccessToken)) {
      modal.ErrorCode = ErrorCodes.AccessTokenGetError;
      return modal;
    }

    const getClientGroupUrl: string = ServiceUrlHelper.getClientGroupsUrl(
      herculesApiBaseUriAsync.serviceUrl,
      engagementId
    );
    const getInternalUsersUrl: string = ServiceUrlHelper.getInternalUsersUrl(
      herculesApiBaseUriAsync.serviceUrl,
      engagementId
    );
    const getTagsUrl: string = ServiceUrlHelper.getTagsUrl(herculesApiBaseUriAsync.serviceUrl, engagementId);
    const getExternalUsersUrl: string = ServiceUrlHelper.getExternalUsersUrl(
      herculesApiBaseUriAsync.serviceUrl,
      engagementId
    );
    const getTimePhasesUrl: string = ServiceUrlHelper.getTimePhasesUrl(
      herculesApiBaseUriAsync.serviceUrl,
      engagementId
    );

    const refSheetUrls = [getClientGroupUrl, getExternalUsersUrl, getInternalUsersUrl, getTagsUrl, getTimePhasesUrl];
    const crPromises = refSheetUrls.map((url) => APIMiddleware.fetch("GET", url, herculesAccessToken, null));

    let responses = await Promise.all(crPromises);

    const errorInApiCall = responses.find((response) => response.errorCode);
    let referenceFormattedData = null;
    if (!errorInApiCall) {
      let referenceFormattedData = await ClientRequestUIExcelInterface.getformatedClientRequestAPIResponse(
        responses,
        ldcVersioning
      );
      let dataItemsEditModel: ServiceDataModel = translateToServiceDataModel(
        responses,
        engagementId,
        referenceFormattedData
      );
      return dataItemsEditModel;
    } else {
      let dataItemsEditModel: ServiceDataModel = translateToServiceDataModel(
        null,
        engagementId,
        referenceFormattedData
      );
      dataItemsEditModel.ErrorCode = errorInApiCall.errorCode;
      return dataItemsEditModel;
    }
  }
}
